<script setup lang="ts"></script>

<template>
  <div class="bg-gray-200 text-gray-700">
    <div class="container py-0.5 text-center">
      <slot />
    </div>
  </div>
</template>
